import React, { useEffect, useState } from "react";
import "../CSS/ItemMaster.css";
import axios from "axios";
import Select from "react-select";
import AllNav from "../Components/Navbar/AllNav";
import LoadingScreen from "./LoadingScreen";
import ExcelJS from "exceljs";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { BsFileEarmarkPdf } from "react-icons/bs";
import { RiFileExcel2Line } from "react-icons/ri";

const MillMaster = () => {
  const BASEURL = process.env.REACT_APP_BASEURL;
  const authToken = window.sessionStorage.getItem("auth-token");
  const [item, setItem] = useState([]);
  const [isloading, setisloading] = useState(true);
  const [chargeCategory, setChargeCategory] = useState("");
  const [chargename, setChargeName] = useState("");
  const [charge, setCharge] = useState("");
  const [fixedorvariable, setfixedorvariable] = useState(false);
  const [listOfCategory, setListOfcategory] = useState([]);
  const [historic, setHistoric] = useState(false);
  const [status, setStatus] = useState("");
  const [search, setSearch] = useState("");
  const [millno, setMillno] = useState("");
  const [millnoList, setMillNoList] = useState([]);

  useEffect(() => {
    getMillNoDetails();
  }, []);

  const filteredData = millnoList?.filter((item) => {
    const searchData = search.toLowerCase().split(" ").filter(Boolean);
    const stat = status;

    if (searchData.length === 0 && !stat) {
      return true;
    }

    const textMatch = searchData.every((term) => {
      return ["MILLNO"].some((key) => {
        const columnValue = String(item[key]).toLowerCase();
        return columnValue.includes(term);
      });
    });

    return textMatch;
  });

  const customStylessSelect = {
    control: (baseStyles, state) => ({
      ...baseStyles,
      minWidth: "250px",
      marginTop: "0px",
      minHeight: "initial",
      height: "35px",
      border: "1px solid",
      paddingBottom: "0px",
      paddingTop: "0px",
      marginLeft: "0px",
      textTransform: "uppercase",
      "@media (max-width: 720px)": {
        minWidth: "181px",
      },
    }),
  };

  const getMillNoDetails = () => {
    axios
      .get(`${BASEURL}/FetchMillDetails`, {
        headers: {
          "auth-token": authToken,
        },
      })
      .then((response) => {
        setisloading(false);
        setMillNoList(response?.data);
      })
      .catch((error) => {
        setisloading(false);
        console.error("Error fetching List Of Mill numbers:", error);
      });
  };

  // Saving
  async function SaveMillMaster() {
    setisloading(true);
    try {
      const response = await axios.post(
        `${BASEURL}/InsertMillNo`,
        {
          MILLNO: millno.toUpperCase(),
        },
        {
          headers: {
            "auth-token": authToken,
          },
        }
      );

      if (response.status === 200) {
        setisloading(false);
        alert(response.data.message);
      } else {
        setisloading(false);
        alert(response.data.err);
      }
    } catch (error) {
      setisloading(false);
      console.error(`Error while saving Charges Master`, error);
      alert(error.response.data.err);
    }
  }

  const handleRowClick = (value, index) => {
    setHistoric(true);
    setMillno(value.MILLNO);
  };

  const ExcelStockData = () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("List Of Mills");
    const rows = document.querySelectorAll(".table_1 tbody tr");

    const columnWidths = [15, 50, 25, 25, 25, 15];

    // Set column widths for the worksheet
    columnWidths.forEach((width, index) => {
      worksheet.getColumn(index + 1).width = width;
    });

    // Add headers
    const headerRow = worksheet.addRow(["MILLNO"]);
    headerRow.eachCell((cell) => {
      cell.font = { bold: true };
    });

    // Add rows from the table
    rows.forEach((row) => {
      const rowData = [];
      row.querySelectorAll("td").forEach((cell) => {
        rowData.push(cell.textContent);
      });
      worksheet.addRow(rowData);
    });

    // Create a blob from the workbook
    workbook.xlsx.writeBuffer().then((buffer) => {
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = "List_Of_Mills.xlsx";
      link.click();
    });
  };

  const PdfStockData = () => {
    const doc = new jsPDF();

    doc.text("List Of Mills", 10, 10);

    const columns = ["MILLNO"];

    const data = filteredData.map((stock) => [stock.MILLNO]);

    doc.autoTable({
      head: [columns],
      body: data,
      startY: 20,
      showHead: "firstPage",
    });

    doc.save("List_Of_Mills.pdf");
  };

  if (isloading) {
    return <LoadingScreen />;
  }

  return (
    <div>
      <AllNav />
      <div className="header__save">
        <h1 style={{ textAlign: "center" }}>Mill Master</h1>
        <div className="header_route">
          <div className="flex">
            <button
              className="Save_import"
              onClick={() => {
                if (millno !== "") {
                  if (window.confirm("Are you sure you don't want to Save")) {
                    window.location.reload();
                  }
                } else {
                  window.location.reload();
                }
              }}
            >
              New
            </button>

            <button
              className="Save_import"
              onClick={async () => {
                if (!millno) {
                  alert("Kindly Supply Mill Number");
                } else {
                  await SaveMillMaster();
                  window.location.reload();
                }
              }}
            >
              Save
            </button>
          </div>
        </div>
      </div>
      <section className="section__Item">
        <div className="section__div section__for__print__excel">
          <div className="item_second_line">
            <div className="item_name" style={{ marginRight: "0px" }}>
              <p>Mill Number</p>
              <input
                type="text"
                className="select_name"
                value={millno}
                onChange={(e) => {
                  setMillno(e.target.value);
                }}
                disabled={historic == true}
              />
            </div>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginTop: "5px",
            }}
          >
            <div style={{ marginRight: "5px" }}>
              <RiFileExcel2Line onClick={ExcelStockData} size={35} />
            </div>
            <div>
              {" "}
              <BsFileEarmarkPdf onClick={PdfStockData} size={35} />
            </div>
          </div>
        </div>
        <div className="search__mill" style={{ marginTop: "5px" }}>
          <div>
            <p>Search</p>
          </div>
          <div>
            <input
              type="text"
              value={search}
              onChange={(e) => {
                setSearch(e.target.value);
              }}
            ></input>
          </div>
        </div>
        <div
          className="visible width__website__lower"
          style={{
            height: "auto",
            padding: "4px",
            zIndex: "0",
          }}
        >
          <table className="table_1">
            <thead>
              <tr className="table-header">
                <td
                  style={{
                    width: "100px",
                    paddingLeft: "10px",
                    paddingRight: "20px",
                    textAlign: "right",
                  }}
                >
                  SNO
                </td>
                <td>MILL NUMBER</td>
              </tr>
            </thead>
            <tbody>
              {filteredData.map((value, index) => (
                <tr
                  onClick={() => {
                    handleRowClick(value, index);
                  }}
                  style={{ cursor: "pointer" }}
                >
                  <td
                    style={{
                      paddingLeft: "10px",
                      paddingRight: "20px",
                      textAlign: "right",
                    }}
                  >
                    {index + 1}
                  </td>
                  <td style={{ textAlign: "left", paddingRight: "30px" }}>
                    {value.MILLNO ? value.MILLNO : "N/A"}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>
    </div>
  );
};

export default MillMaster;
